var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 14.5013C11.9997 13.0868 11.4378 11.7303 10.4376 10.7301C9.43738 9.72987 8.08083 9.16797 6.66634 9.16797C5.25185 9.16797 3.8953 9.72987 2.89511 10.7301C1.89491 11.7303 1.33301 13.0868 1.33301 14.5013",
    stroke: "#0F172A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 9.16667C8.50729 9.16667 9.99967 7.67428 9.99967 5.83333C9.99967 3.99238 8.50729 2.5 6.66634 2.5C4.82539 2.5 3.33301 3.99238 3.33301 5.83333C3.33301 7.67428 4.82539 9.16667 6.66634 9.16667Z",
    stroke: "#0F172A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 13.8315C14.6669 11.5848 13.3335 9.49818 12.0002 8.49818C12.4385 8.16936 12.7889 7.73757 13.0206 7.24102C13.2522 6.74448 13.3579 6.19849 13.3282 5.65138C13.2985 5.10427 13.1345 4.5729 12.8505 4.10431C12.5666 3.63572 12.1715 3.24435 11.7002 2.96484",
    stroke: "#0F172A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.5b0d2b79daeec903937db42fad36d0f7.svg";
export { ForwardRef as ReactComponent };